// @flow
import * as React from "react";
import styled from "styled-components";

import Select from "./Select";
import { Flex, Header as RawHeader } from "./shared-styles";
import { fontSize } from "../common/styled-mixins";

const Container = styled(Flex)`
  direction: ${({ theme }) => theme.direction};
  margin-left: auto;

  :not(:first-of-type) {
    margin-right: auto;
  }

  @media (min-width: 960px) {
    max-width: ${props => (props.headerWidth ? "180px" : "auto")};
  }

  @media (max-width: 959px) {
    flex-direction: column;
    align-items: flex-start;
    margin-left: 0;
    margin-right: 0;
  }

  @media (min-width: 667px) and (max-width: 959px) {
    :not(:first-of-type) {
      margin-left: 0.286em;
    }
  }

  @media (min-width: 480px) and (max-width: 666px) {
    :first-of-type {
      margin-bottom: 0.286em;
    }
  }

  @media (max-width: 479px) {
    flex-direction: row;
    align-items: center;
    width: 100%;
    margin-bottom: 0.286em;
  }
`;

export const SelectsContainer = styled.div`
  flex: 1;

  @media (min-width: 667px) {
    display: flex;
  }

  @media (min-width: 960px) {
    flex-direction: row;
    flex-shrink: 0;
  }
`;

const Header = styled(RawHeader)`
  display: block;

  @media (max-width: 959px) {
    padding-left: 0.286em;
    font-size: ${fontSize(16)};
    line-height: 1.125em;
    color: #717171;
  }

  @media (max-width: 666px) {
    font-size: ${fontSize(14)};
  }

  @media (min-width: 480px) and (max-width: 666px) {
    margin-bottom: 0.286em;
  }

  @media (max-width: 479px) {
    margin-right: 0;
    padding-left: 0;
    flex: 0 1 30%;
  }
`;

const Wrapper = styled.div`
  @media (max-width: 479px) {
    flex: 1 1 auto;
  }
`;

type Props = {
  headerWidth?: string,
  children?: React.Node
};

function HistorySelect({ children, headerWidth, ...props }: Props) {
  return (
    <Container headerWidth={headerWidth}>
      {children && <Header headerWidth={headerWidth}>{children}</Header>}
      <Wrapper className="needsclick">
        <Select {...props} />
      </Wrapper>
    </Container>
  );
}

export default HistorySelect;



// WEBPACK FOOTER //
// ./src/components/HistoryPages/HistorySelect.js